import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Translate } from "react-localize-redux";
import { sendFeedbackAction } from '../../../redux/actions/profile.actions';
import InputField from '../InputField';
import './styles.scss';

const CHAR_LIMIT = 500;

export class FeedbackForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { commentWordCount: CHAR_LIMIT };
  }

  handleSendFeedback = (values) => {
    this.props.sendFeedbackAction(values);
  }

  updateWordCount = event => {
    console.log(event);
    this.setState({ commentWordCount: CHAR_LIMIT - event.currentTarget.value.length })
}

  render() {
    const { handleSubmit, feedback } = this.props;
    return (
      <div className="col-lg-12 text-center">
        <h3 id="feedback-header" className="modal-title">
          <Translate id="FeedbackText" />
        </h3>
        <br/>
        <form onSubmit={handleSubmit(this.handleSendFeedback)}>
          <Field
            label={<Translate id="Email" />}
            hideLabel={false}
            name="email"
            type="email"
            id="email-input"
            textAlign="center"
            component={InputField}
          />
          <Field
            label={<Translate id="nameText" />}
            hideLabel={false}
            name="name"
            type="text"
            id="name-input"
            textAlign="center"
            component={InputField}
          />
          <Field
            label={<Translate id="Subject" />}
            hideLabel={false}
            name="subject"
            type="text"
            id="subject-input"
            textAlign="center"
            component={InputField}
          />
          <Field
            label={<Translate id="Comments" />}
            hideLabel={false}
            name="message"
            type="textarea"
            maxLength={500}
            rows={8}
            id="message-input"
            component={InputField}
            onChange={this.updateWordCount}
          />
          <br/>
          <div>{`${this.state.commentWordCount} / 500`}</div>
          <br/>

          {feedback.submitted && <p>Feedback submitted</p>}

          {feedback.submitted ?
            <button
              className="btn btn-primary edit-profile-header-cancel-btn"
              onClick={this.props.toggleModal}>
              <Translate id="Close" />
            </button>
            :
            <button
              type="submit"
              id="submit-btn"
              disabled={!this.props.valid}
              className="btn btn-primary">
              <Translate id="Send" />
            </button>
          }

        </form>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};

  if (!values.subject) {
    errors.subject = "Enter a subject"
  }

  if (!values.message) {
    errors.message = "Enter a message"
  }

  return errors;
}

const connectedReduxForm =  reduxForm({
  validate,
  form: 'FeedbackForm'
})(connect(({ profile }) => ({ feedback: profile.feedback }), { sendFeedbackAction })(FeedbackForm));

export default connectedReduxForm;


// WEBPACK FOOTER //
// ./src/components/forms/FeedbackForm/FeedbackForm.jsx